import { createSlice } from '@reduxjs/toolkit';

interface State {
  isLoading: boolean;
  error: boolean;
  bulkUploadResponse: any;
  bulkUploadStatus: string;
}

const initialState: State = {
  isLoading: true,
  error: false,
  bulkUploadResponse: {},
  bulkUploadStatus: ""
};

export const updateProductQtySlice = createSlice({
  name: 'updateProducts',
  initialState,
  reducers: {
    updateProductQtyStart: (state: State, action) => ({
      ...initialState,
      isLoading: true
    }),
    updateProductQtySuccess: (state: State, action) => ({
      ...state,
      isLoading: false,
      error: false,
      bulkUploadResponse: action.payload.bulkUploadResponse,
      bulkUploadStatus: action.payload.status
    }),
    updateProductQtyFailure: (state: State) => ({
      ...state,
      error: true,
      isLoading: false,
    }),
    statusDismiss: (state: State) => ({
      ...initialState
    })
  }
});

export const {
    updateProductQtyFailure,
    updateProductQtyStart,
    updateProductQtySuccess,
    statusDismiss
} = updateProductQtySlice.actions;
export default updateProductQtySlice.reducer;
